<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" variant="primary" size="sm" @click.prevent="showOpcionesFiltro = !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group>
            <b-form-radio v-model="filtro.filtroPeriodo" name="filtroPeriodoOption" :value="Boolean(true)" stacked>Filtrar por período</b-form-radio>

            <b-collapse id="filtroOpcionPeriodo" class="mt-2" v-model="showOpcionesPeriodo">
              <b-form-group label="Desde" label-for="fechaDesde" :label-cols="labelCols" horizontal>
                <b-form-input id="fechaDesde" v-model="filtro.fechaDesde" type="date"> </b-form-input>
              </b-form-group>

              <b-form-group label="Hasta" label-for="fechaHasta" :label-cols="labelCols" horizontal>
                <b-form-input id="fechaHasta" v-model="filtro.fechaHasta" type="date"> </b-form-input>
              </b-form-group>

              <b-form-group label="Cliente" label-for="cliente" :label-cols="labelCols" horizontal>
                <b-input-group>
                  <b-input-group-append class="filter-search-icons" @click="seleccionarCliente">
                    <b-input-group-text>
                      <i :class="{ 'fa fa-search': !filtro.cliente, 'fa fa-remove': filtro.cliente }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <b-form-input id="cliente" :value="clienteNombre" readonly type="text" />
                </b-input-group>
              </b-form-group>
            </b-collapse>

            <b-form-radio v-model="filtro.filtroNumero" name="filtroNumeroOption" :value="Boolean(true)" stacked>Filtrar por número</b-form-radio>

            <b-collapse id="filtroOpcionNumero" class="mt-2" v-model="showOpcionesNumero">
              <b-form-group label="Nro. Punto Venta" label-for="numeroPuntoVenta" :label-cols="labelCols" horizontal>
                <b-form-input id="numeroPuntoVenta" v-model="filtro.numeroPuntoVenta" type="text"> </b-form-input>
              </b-form-group>

              <b-form-group label="Nro. Comprobante" label-for="numero" :label-cols="labelCols" horizontal>
                <b-form-input id="numero" v-model="filtro.numero" type="text"> </b-form-input>
              </b-form-group>
            </b-collapse>
          </b-form-group>

          <b-form-group :label-cols="labelCols" horizontal>
            <b-form-checkbox id="sortByDescending" v-model="filtro.sortByDescending" :value="Boolean(true)" :unchecked-value="Boolean(false)">
              Ordenar comprobantes en forma descendente
            </b-form-checkbox>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button" @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchClienteModal" title="Seleccionar Cliente" header-bg-variant="light" hide-footer lazy modal-class="clientes-search-modal">
      <app-search-cliente :incluirInactivos="true" @clienteSeleccionado="clienteSeleccionado"> </app-search-cliente>
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue'
import moment from 'moment'

export default {
  components: {
    appSearchCliente: SearchCliente,
  },
  props: {
    filtroPeriodo: {
      type: Boolean,
      default: true,
    },
    filtroNumero: {
      type: Boolean,
      default: false,
    },

    fechaDesde: {
      type: String,
      default: '',
    },
    fechaHasta: {
      type: String,
      default: '',
    },
    cliente: {
      type: Object,
      default: null,
    },
    numero: {
      type: Number,
      default: 0,
    },
    numeroPuntoVenta: {
      type: Number,
      default: 0,
    },
    comprobanteTipo: {
      type: Object,
      default: null,
    },

    sortByDescending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtro: {
        filtroPeriodo: true,
        filtroNumero: false,
        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
        numero: 0,
        numeroPuntoVenta: 0,
        comprobanteTipo: null,
        sortByDescending: false,
      },

      showOpcionesFiltro: Boolean(false),
      showOpcionesPeriodo: true,
      showOpcionesNumero: false,

      labelCols: 2,
    }
  },
  created() {
    this.filtro.filtroPeriodo = this.filtroPeriodo
    this.filtro.filtroNumero = this.filtroNumero
    this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD')
    this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD')
    this.filtro.cliente = this.cliente
    this.filtro.numero = this.numero
    this.filtro.numeroPuntoVenta = this.numeroPuntoVenta
    this.filtro.comprobanteTipo = this.comprobanteTipo
    this.filtro.sortByDescending = this.sortByDescending
  },
  computed: {
    clienteNombre: function () {
      return this.filtro.cliente ? this.filtro.cliente.nombre.trim() : ''
    },
    comprobanteTipoNombre: function () {
      return this.filtro.comprobanteTipo ? this.filtro.comprobanteTipo.nombre.trim() : ''
    },
  },
  methods: {
    filtrar() {
      let filtrar = true

      if (/true/i.test(this.filtro.filtroNumero)) {
        let numero = parseInt(this.filtro.numero)

        if (numero == 0) {
          filtrar = false
        }
      }

      if (filtrar) {
        this.$emit('filtrar', this.filtro)
      }
    },
    limpiarFiltro() {
      this.filtro.cliente = null
      this.filtro.numero = 0
      this.filtro.numeroPuntoVenta = 0
      this.filtro.comprobanteTipo = null
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null
      } else {
        this.$refs.searchClienteModal.show()
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente
      this.$refs.searchClienteModal.hide()
    },
  },
  watch: {
    'filtro.filtroPeriodo': function (newVal, oldVal) {
      if (newVal) {
        this.showOpcionesPeriodo = true

        this.filtro.filtroNumero = false
      } else {
        this.showOpcionesPeriodo = false
      }
    },
    'filtro.filtroNumero': function (newVal, oldVal) {
      if (newVal) {
        this.showOpcionesNumero = true

        this.filtro.filtroPeriodo = false
      } else {
        this.showOpcionesNumero = false
      }
    },
  },
}
</script>

<style></style>
